import Card from "../../../../../src/components/card/Card";
import { Playground, Props } from 'docz';
import * as React from 'react';
export default {
  Card,
  Playground,
  Props,
  React
};